export const toTerbilang = (num) => {
    const satuan = [
        '', 'satu', 'dua', 'tiga', 'empat', 'lima',
        'enam', 'tujuh', 'delapan', 'sembilan', 'sepuluh', 'sebelas',
    ];

    num = Math.floor(num);

    if (num < 12) return satuan[num];
    if (num < 20) return toTerbilang(num - 10) + ' belas';
    if (num < 100) return toTerbilang(Math.floor(num / 10)) + ' puluh ' + toTerbilang(num % 10);
    if (num < 200) return 'seratus ' + toTerbilang(num - 100);
    if (num < 1000) return toTerbilang(Math.floor(num / 100)) + ' ratus ' + toTerbilang(num % 100);
    if (num < 2000) return 'seribu ' + toTerbilang(num - 1000);
    if (num < 1000000) return toTerbilang(Math.floor(num / 1000)) + ' ribu ' + toTerbilang(num % 1000);
    if (num < 1000000000) return toTerbilang(Math.floor(num / 1000000)) + ' juta ' + toTerbilang(num % 1000000);
    return 'terlalu besar';
};
